import type { NavBarItem } from '@gm-commercial/navbar-model';
import { useLocation } from 'react-router-dom';

import ContentNavDrawerItem from './ContentNavDrawerItem';

export type NavDrawerItemProps = NavBarItem & {
  isNavDrawerOpen?: boolean;
  currentPagePath?: string;
  typographyClass?: 'body_medium' | 'body_regular';
};

const NavDrawerItem = (item: NavDrawerItemProps): JSX.Element => {
  const { pathname } = useLocation();

  const itemWithDefaults = !item.typographyClass
    ? { typographyClass: 'body_medium' as const, ...item }
    : item;

  return (
    <ContentNavDrawerItem {...itemWithDefaults} currentPagePath={pathname} />
  );
};

export default NavDrawerItem;
